import classNames from 'clsx';
import { NavLink, useLocation } from 'react-router';

import type { NavLinkProps } from 'react-router';

import styles from './MenuLink.module.css';

/** Represents a component for a [NavLink](https://reactrouter.com/en/main/components/nav-link) with styling. */
// Omit style so it cannot be accidentally used
export interface MenuLinkProps extends Omit<NavLinkProps, 'style'> {
  overrideDefault?: boolean;
}

export const MenuLink = ({ overrideDefault, ...props }: MenuLinkProps) => {
  const location = useLocation();

  // Helper function to remove trailing 's' from a string
  const singularize = (str: string) => str.replace(/s$/, '');

  // Check if 'to' path (singular version) matches any segment (singular version)
  const isActiveSingular = (to: string) => {
    const currentSegments = location.pathname.split('/').filter(Boolean);
    const latestToPath = to.split('/').filter(Boolean).slice(-1)[0]; // return only lates path removing any prepend path
    const singularizedToPath = singularize(latestToPath);

    return currentSegments.some((segment) => singularize(segment) === singularizedToPath);
  };

  return (
    <NavLink
      {...props}
      className={({ isActive }) =>
        classNames(styles['menu-link'], {
          [styles['menu-link--active']]: overrideDefault ? '' : isActive || isActiveSingular(props.to as string),
        })
      }
    />
  );
};
